import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';

import Badge from 'react-bootstrap/Badge';
import Alert from 'react-bootstrap/Alert';

import loadable from '@loadable/component';

import { Water, Recycle, Clock, Percent, PatchQuestion, Rulers, LifePreserver } from 'react-bootstrap-icons';
import { ExclamationCircleFill, CheckCircleFill, SlashCircleFill, QuestionCircleFill } from 'react-bootstrap-icons';

import GoverningBodyName from '../GoverningBodyName.js';
import SewageDischargeStationOperationalHistoryChart from '../SewageDischargeStationOperationalHistoryChart.js';
import SewageDischargeStationSpillHistoryChart from '../SewageDischargeStationSpillHistoryChart.js';
import SpillCountExplainModal from '../SpillCountExplainModal.js';

import NearBySewagePlace from '../NearBySewagePlace.js';

import CommonHeaders from '../helmet-headers/CommonHeaders.js';

import { formatTimestamp } from '../../lib/formatHelpers.js';

import TrafficLight from '../TrafficLight.js';
import CentralLink from '../CentralLink.js';

import SewageTimeline from '../SewageTimeline.js';

function calculateMinutesSince(eventStartUTC) {
    // Parse the event start time as a Date object in UTC
    const eventStart = new Date(eventStartUTC);

    // Get the current time in UTC
    const now = new Date();

    // Calculate the difference in milliseconds
    const differenceMs = now.getTime() - eventStart.getTime();

    // Convert the difference to minutes
    const minutesDifference = Math.floor(differenceMs / 1000 / 60);

    return minutesDifference;
}


function getStatusText(status) {
	let statusText = <span><b><i>status is unknown</i></b></span>
	switch(status) {
		case 'START':
			statusText = <Badge pill bg="danger">is currently being discharged</Badge>;
			break;
		case 'STOP':
			statusText = <Badge pill bg="success">is not currently being discharged</Badge>;
			break;
	}
	return statusText;
}

const RenderStationSewageDischargeLive = function({ isMissingMetrics, station, qualifierType, computedQualifierType }) {

	
	let title = null;
	let description = null;
	if(station && station.liveSewage) {
		title = station.stationName + " - Live sewage discharge information";
		description = "View live sewage discharge information for the " + station.stationName + " station";
	}

	let sewageEvents = station && station.liveSewageHistory ? [...station.liveSewageHistory] : [];
	if(station && station.liveSewage && station.liveSewage.status === 'START') {
		sewageEvents.push({
			startTimestamp: station.liveSewage.latestEventStart,
			endTimestamp: (new Date()).toISOString()
		})
	}

	return <Row>
		<CommonHeaders
			title={title}
			description={description}
		/>
		{station.nearBySewageReports && Object.keys(station.nearBySewageReports).length > 0 ? <Col xs={12}>
			<Row>
				<Col xs={12} className="bg-secondary text-white header-bold">View Reports that include this Station</Col>
				<Col xs={12}>
					{Object.keys(station.nearBySewageReports).map(function(placeId) {
						let place = station.nearBySewageReports[placeId];
						return <NearBySewagePlace place={place} />;
					})}	
				</Col>
			</Row>
		</Col> : null}
		{station.liveSewage && station.liveSewage.operator ? <Col xs={12}>
			<CentralLink to={"/data-explorer/search-sewage-operator/" + station.liveSewage.operator}>
				<Button size="sm" variant="dark">{station.liveSewage.operator}</Button>
			</CentralLink>
		</Col> : null}
		<Col xs={12} className="header-bold bg-dark text-white mt-1">Live Sewage Status</Col>
		{station.liveSewage && station.liveSewage.metricId ? <Col xs={12}>
			<Row className="align-items-center">
				<Col xs={3} className="mt-1">
					<center>
						<TrafficLight status={station.liveSewage.status} />
					</center>
				</Col>
				<Col xs={9} className="d-flex align-items-center">
					<Row>
						<Col xs={12}>Sewage {getStatusText(station.liveSewage.status)}, as of our last update for this station at <b>{formatTimestamp(station.liveSewage.lastUpdated)}</b>.</Col>
						{station.liveSewage.status === 'START' ? <Col xs={12}>The discharge began at <Badge pill bg="danger">{formatTimestamp(station.liveSewage.latestEventStart)}<b></b></Badge>, this was <Badge pill bg="dark">{calculateMinutesSince(station.liveSewage.latestEventStart)} minutes ago*</Badge>.</Col> : null}
						{station.liveSewage.receivingWaterCourse ? <Col xs={12}>The water course declared as receiving spills from this monitor is <Badge pill bg="primary">{station.liveSewage.receivingWaterCourse}</Badge>.</Col> : null}
						{station.liveSewage.operator ? <Col xs={12}>The declared operator of this monitor is <Badge pill bg="dark">{station.liveSewage.operator}</Badge></Col> : null}
					</Row>
				</Col>
				<Col xs={12}>
					<SewageTimeline events={sewageEvents} dischargingNow={station && station.liveSewage && station.liveSewage.status === 'START'} />
				</Col>
			</Row>
		</Col> : <Col xs={12}>No data to display at this time</Col>}
		<Col xs={12}>
			<hr />
			<span style={{fontSize: "0.8em"}}>
				<b>*Note</b>: Minutes shown are from the start time to your current time, please take into account that the station could have stopped discharging since the last update. This is because updates are not provided in true real time, but are delayed by around an hour.
			</span>
			<hr />
			<span style={{fontSize: "0.8em"}}>
				<b>
					FloodMapper is not affiliated with this monitoring stations operator(s) or any other entities that may be mentioned on this page.<br />
					All trademarks and registered trademarks are the property of their respective owners.
				</b><br />
				<b>Operator comments are presented, unedited, as they were received by us and do not reflect our views or position</b>
			</span>
			<hr />
		</Col>
	</Row>;
};


export default RenderStationSewageDischargeLive;